module.exports = __webpack_public_path__ + "img/shape_cylinder_l.5f44212f.svg";